import React from "react";
import EvalResponses from "./EvalResponses";

const RATING_OPTIONS = [
  'Significantly',
  'Somewhat',
  'Not at all',
  'Not a goal'
];

export default function EvalProjectEducatorResponses(props) {
  return (
    <EvalResponses
      {...props}
      table="evaluationProjectEducator"
      ratingOptions={RATING_OPTIONS}
    />
  );
}
